"use client"

import React from 'react'

export default function DragDropArea({ isDragging, setIsDragging, onDrop, children, onClick }: { isDragging: boolean, setIsDragging: (v: boolean) => void, onDrop: (files: File[]) => void, children: React.ReactNode, onClick?: () => void }) {
  return (
    <div
      onClick={() => onClick && onClick()}
      onDragOver={(e) => e.preventDefault()}
      onDragEnter={(e) => { e.preventDefault(); setIsDragging(true) }}
      onDragLeave={(e) => { e.preventDefault(); setIsDragging(false) }}
      onDrop={(e) => { e.preventDefault(); setIsDragging(false); const dropped = Array.from(e.dataTransfer?.files || []); onDrop(dropped as File[]) }}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      className={`p-3 border-dashed border-2 rounded-xl text-sm text-muted-foreground flex items-center justify-center gap-3 ${isDragging ? 'border-primary bg-primary/5' : 'border-border/50'} ${onClick ? 'cursor-pointer' : ''}`}
    >
      {children}
    </div>
  )
}
